/* eslint-disable indent */
import axios from "axios";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { frequentUsersList } from "../../Redux/Actions";
import Spinner from "../../assets/images/Spinner.gif";
import ExcelIcon from "../../assets/images/excel.png";
import { ApiUrl } from "../Common/ApiUrl";
import { Constants } from "../Common/Constants";
import DateRangePicker from "../Common/Fields/DateRangePicker";
import ReactPagination from "../Common/Fields/ReactPagination";
import ReactSelect from "../Common/Fields/ReactSelect";
import titleCase from "../Common/Functions/titleCase";
import usePermissions from "../Common/Functions/usePermissions";
import PageHeader from "../Common/PageHeader";
import { RoutesUrl } from "../Common/RoutesUrl";
import TableList from "../Common/UiModel/TableList";


const initDate = {
  startDate: new Date(),
  endDate: new Date(),
  key: "selection",
};

const UsersList = () => {
  const dispatch = useDispatch();
  const { frequentuserlist } = useSelector((state) => state.Reports);
  const [usersData, setUsersData] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [selectedFreq, setSelectedFreq] = useState(Constants.freqOptions[0]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [showCalender, setShowCalender] = useState(false);
  const calendarRef = useRef(null);
  const [initialDate, setInitialDate] = useState(initDate);
  const [range, setRange] = useState({});

  dayjs.extend(utc);
  dayjs.extend(timezone);


  const [selectedGender, setSelectedGender] = useState(
    Constants.genderOptions[0]
  );
  const viewPermission = usePermissions(
    Constants.permission.DOWNLOAD_REPORT_VIEW
  );
  const onExportExcel = async () => {
    setLoader(true);
    // const data = {
    //   // days: activetab,
    //   gender: selectedGender.value,
    //   // bodyPart: bodyPart?.value || null,
    // };
    try {
      const tz = dayjs.tz.guess();


      const startOfDayISO = range?.start_date ? dayjs.tz(range.start_date, tz).startOf("day").toISOString() : null;
      const endOfDayISO = range?.start_date ? dayjs.tz(range?.end_date, tz).endOf("day").toISOString() : null;

      // const paramsObj = { startDate: startOfDayISO, endOfDayISO: endOfDayISO, search: search, order: selectedFreq.label, gender: selectedGender.value };
      const paramsObj = {
        ...(startOfDayISO && { startDate: startOfDayISO }),
        ...(endOfDayISO && { endDate: endOfDayISO }),
        ...(search !== "" && { search }),
        order: selectedFreq.label,

        ...(selectedGender?.value !== null && { gender: selectedGender.value }),
      };

      const searchParams = new URLSearchParams(paramsObj);


      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${ApiUrl.FREQUENT_USER_EXCEL}?${searchParams}`,
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              Constants.accessToken
            )}`,
          },
        }
      );
      setLoader(false);
      // Create a Blob from the data and generate a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "frequent-users-report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setLoader(false);
      console.error("Error downloading the Excel file:", error);
    }
  };
  useEffect(() => {
    // Users list API

    document.addEventListener("mousedown", handleClickOutside);
    getUsersData();
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Set user list data
    setUsersData(frequentuserlist?.items);
  }, [frequentuserlist]);

  // Columns for User list
  const columns = [
    {
      name: Constants.id,
      width: "6%",
      cell: (_row, i) =>
        pageIndex * Constants.limitCount - Constants.limitCount + i + 1,
    },
    {
      name: Constants.email,
      selector: (row) => (
        <Link to={`${RoutesUrl.users}/${row?._id}`}>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={row?.userData?.email}
          >
            {row?.userData?.email}
          </span>
        </Link>
      ),
    },
    {
      name: Constants.name,
      selector: (row) => {
        const { userName, name, firstName, lastName } = row?.userData || {};
        const fullName =
          firstName && lastName ? `${firstName} ${lastName}` : null;
        return fullName ?? name ?? userName ?? Constants.na;
      }
    },
    {
      name: Constants.gender,
      selector: (row) => titleCase(row?.userData?.gender || Constants.na),
    },
    {
      name: Constants.workoutCount,
      selector: (row) => row?.countWorkout,
    },
    {
      name: Constants.goals,
      selector: (row) => row?.userData?.goals?.type || Constants.na,
    },
  ];

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    // De-bounce function for search with delay of 500 seconds
    if (search) {
      const delayDebounceFn = setTimeout(() => {
        getUsersData(search);
      }, 500);
      return () => {
        clearTimeout(delayDebounceFn);
      };
    }
  }, [search]);

  const getUsersData = (search) => {
    // User list API based on all filters

    const tz = dayjs.tz.guess();
    // const startOfDayISO = dayjs.tz(range?.start_date, tz).startOf("day").toISOString();
    // const endOfDayISO = dayjs.tz(range?.end_date, tz).endOf("day").toISOString();

    const startOfDayISO = range?.start_date ? dayjs.tz(range.start_date, tz).startOf("day").toISOString() : null;
    const endOfDayISO = range?.start_date ? dayjs.tz(range?.end_date, tz).endOf("day").toISOString() : null;

    const data = {
      ascending: selectedFreq.value,
      gender: selectedGender.value,
      search,
      startDate: startOfDayISO,
      endDate: endOfDayISO,
      tz
    };
    dispatch(frequentUsersList(data));
  };

  // Pagination fuction
  const handleOffset = (newOff) => {
    const tz = dayjs.tz.guess();
    // const startOfDayISO = dayjs.tz(range?.start_date, tz).startOf("day").toISOString();
    // const endOfDayISO = dayjs.tz(range?.end_date, tz).endOf("day").toISOString();

    const startOfDayISO = range?.start_date ? dayjs.tz(range.start_date, tz).startOf("day").toISOString() : null;
    const endOfDayISO = range?.start_date ? dayjs.tz(range?.end_date, tz).endOf("day").toISOString() : null;

    const data = {
      skip: newOff,
      limit: Constants.limitCount,
      ascending: selectedFreq.value,
      gender: selectedGender.value,
      search,
      startDate: startOfDayISO,
      endDate: endOfDayISO,
      tz
    };
    dispatch(frequentUsersList(data));
  };

  const handleFreq = (selected) => {
    console.log(selected);
    setSelectedFreq(selected);
    setPageIndex(1);

    const tz = dayjs.tz.guess();
    const startOfDayISO = dayjs.tz(range?.start_date, tz).startOf("day").toISOString();
    const endOfDayISO = dayjs.tz(range?.end_date, tz).endOf("day").toISOString();


    const data = {
      ascending: selected.value,
      gender: selectedGender.value,
      search,
      startDate: startOfDayISO,
      endDate: endOfDayISO,
      tz
    };
    dispatch(frequentUsersList(data));
  };

  const handleGender = (selected) => {
    setSelectedGender(selected);
    setPageIndex(1);

    const tz = dayjs.tz.guess();
    // const startOfDayISO = dayjs.tz(range?.start_date, tz).startOf("day").toISOString();
    // const endOfDayISO = dayjs.tz(range?.end_date, tz).endOf("day").toISOString();

    const startOfDayISO = range?.start_date ? dayjs.tz(range.start_date, tz).startOf("day").toISOString() : null;
    const endOfDayISO = range?.start_date ? dayjs.tz(range?.end_date, tz).endOf("day").toISOString() : null;

    const data = {
      ascending: selectedFreq.value,
      gender: selected.value,
      search,
      startDate: startOfDayISO,
      endDate: endOfDayISO,
      tz
    };
    dispatch(frequentUsersList(data));
  };

  const onResetFilter = () => {
    setSelectedGender(Constants.genderOptions?.[0]);
    setSelectedFreq(Constants.freqOptions?.[0]);
    setSearch("");
    setPageIndex(1);
    setRange({});
    setInitialDate(initDate);
    dispatch(frequentUsersList());
  };

  const onDateFilter = () => {
    setShowCalender(false);
    const tz = dayjs.tz.guess();
    const startOfDayISO = dayjs.tz(range?.start_date, tz).startOf("day").toISOString();
    const endOfDayISO = dayjs.tz(range?.end_date, tz).endOf("day").toISOString();
    const data = {
      ascending: selectedFreq.value,
      gender: selectedGender.value,
      search,
      startDate: startOfDayISO,
      endDate: endOfDayISO,
      tz
    };

    dispatch(frequentUsersList(data));
  };

  const onRangeChange = (range) => {
    setInitialDate({
      startDate: range?.[0]?.startDate,
      endDate: range?.[0]?.endDate,
      key: "selection",
    });
    setRange({
      start_date: dayjs(range?.[0]?.startDate).format("YYYY-MM-DD"),
      end_date: dayjs(range?.[0]?.endDate).format("YYYY-MM-DD"),
    });
    setPageIndex(1);
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalender(false);
    }
  };

  return (
    <div className="container-xxl">
      <div className="mt-3">
        <PageHeader pagetitle={Constants.frequentUsers} />
      </div>
      <div className="row mb-5 align-items-end position-relative justify-content-end">
        <div className="col-md-2">
          <div className="search-w pull-right space-calender2 position-relative">
            <div
              className={`calender-outer pos_inherit ${range?.start_date ? "calender-active" : ""
                }`}
            >
              <i
                style={{
                  cursor: "pointer",
                  fontSize: "25px",
                }}
                className="fa fa-calendar"
                aria-hidden="true"
                onClick={() => {
                  setShowCalender((prevState) => !prevState);
                }}
              ></i>
            </div>
            <div className="row">
              {showCalender && (
                <div ref={calendarRef} className="date-pos">
                  <div>
                    <DateRangePicker
                      initialDate={initialDate}
                      rangeSelected={(range) => {
                        onRangeChange(range);
                      }}
                    />
                  </div>
                  <div className="appy-btn">
                    <Button
                      className="text-uppercase fw-bold text-center mx-auto d-block"
                      onClick={() => {
                        onDateFilter();
                      }}
                    >
                      {Constants.apply}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <ReactSelect
            label={`${Constants.gender}`}
            required={false}
            options={Constants.genderOptions}
            onChange={(selected) => handleGender(selected)}
            value={selectedGender}
          />
        </div>
        <div className="col-md-2">
          <ReactSelect
            label={`${Constants.frequency}`}
            required={false}
            options={Constants.freqOptions}
            onChange={(selected) => handleFreq(selected)}
            value={selectedFreq}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">{Constants.search}</label>
          <input
            className="px-2 filter-sec-trans"
            type="search"
            value={search}
            placeholder={Constants.searchByEmail}
            onChange={(event) => {
              setSearch(event.target.value);
              setPageIndex(1);
              if (event.target.value === "") {
                setSearch("");
                getUsersData("");
              }
            }}
          ></input>
        </div>
        <div className="col-md-2 reset-btn" style={{ display: "flex", justifyContent: "space-around" }}>
          <button
            className="btn btn-primary text-uppercase px-4  cross-reset p-right fw-bold"
            onClick={() => onResetFilter()}
          >
            {Constants.reset}
          </button>

          {viewPermission && (
            <>
              {loader ? (
                <div className="col-md-2 ">
                  <img src={Spinner} alt="spinner" width="40px" height="40px" />
                </div>
              ) : (
                // <div className=" ">
                <div className="btn-hover">
                  <Link
                    onClick={() => {
                      onExportExcel();
                    }}
                    title=""
                    className="btn btn-primary text-uppercase"
                  >
                    <img
                      src={ExcelIcon}
                      alt="excel-icon"
                      className="img-excel"
                    />
                    {Constants.export}
                  </Link>
                </div>
                // </div>
              )}
            </>
          )}
        </div>
      </div>
      <TableList
        columns={columns}
        data={usersData}
        defaultSortFieldId
        highlightOnHover
      />
      {frequentuserlist?.totalCount > Constants.limitCount && (
        <ReactPagination
          itemsPerPage={Constants.limitCount}
          total={frequentuserlist?.totalCount}
          page={(target) => setPageIndex(target + 1)}
          newOffset={handleOffset}
          pageIndex={pageIndex - 1}
        />
      )}
    </div>
  );
};

export default UsersList;
